import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { getSizeConfig } from '../dorian-shared/getSizeConfig';
import { isMobile } from './isMobile';
import cs from './PageLayout.module.css';
import { PopupProvider } from './PopupProvider/PopupProvider';

export function PageLayout() {
  useEffect(() => {
    document.body.style.backgroundColor = 'var(--base-black)';
    return () => {
      document.body.style.backgroundColor = 'var(--base-background-color)';
    };
  }, []);

  const sizeConfig = getSizeConfig();
  return isMobile ? (
    <div className={cs.streamContainer} style={sizeConfig}>
      <PopupProvider>
        <Outlet />
      </PopupProvider>
    </div>
  ) : (
    <div className={cs.container}>
      <div className={cs.streamContainer} style={sizeConfig}>
        <PopupProvider>
          <Outlet />
        </PopupProvider>
      </div>
    </div>
  );
}
